import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormArray, AbstractControl } from '@angular/forms';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { PaginationComponent } from '../../../components/pagination/pagination.component';


import { firstValueFrom } from 'rxjs';
import { NgxEchartsModule } from 'ngx-echarts';
import { EChartsOption } from 'echarts';
import { CourseService } from '../../courses/course.service';
import { ToasterService } from '../../../providers/toaster/toaster.service';
import { environment } from '../../../../environments/environment';
import { AssociateService } from '../associate.service';
import { ChangeDetectorRef } from '@angular/core';
import {
  nameValidator,
  aboutCollegeValidator,
  addressValidator,
  indianMobileValidator,
  emailValidator,
  usernameValidator,
  passwordValidator,
  designationValidator,
  instituteNameValidator,
} from '../../../utils/associates_validators/associates-validators';

type AssociateCourse = {
  id: number;
  name: string;
  thumbnail: string;
};

@Component({
  selector: 'app-create-associate',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, NgxEchartsModule, PaginationComponent],
  templateUrl: './create-associate.component.html',
  styleUrl: './create-associate.component.css'
})
export class CreateAssociateComponent implements OnInit {
  createForm!: FormGroup;

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  get adminContacts(): FormArray {
    return this.createForm.get('adminContacts') as FormArray;
  }

  createAdminContact(): FormGroup {
    return this.fb.group({
      number: ['', [Validators.required, indianMobileValidator]]
    });
  }

  addAdminContact() {
    this.adminContacts.push(this.createAdminContact());
  }

  removeAdminContact(index: number) {
    if (this.adminContacts.length > 1) this.adminContacts.removeAt(index);
  }

  get adminEmails(): FormArray {
    return this.createForm.get('adminEmails') as FormArray;
  }

  createAdminEmail(): FormGroup {
    return this.fb.group({
      email: ['', [Validators.required, Validators.maxLength(100), emailValidator]]
    });
  }

  addAdminEmail() {
    this.adminEmails.push(this.createAdminEmail());
  }

  removeAdminEmail(index: number) {
    if (this.adminEmails.length > 1) this.adminEmails.removeAt(index);
  }
  activeTab: number = 0;

  submitAttempted = false;

  cities    = ['Jalgaon', 'Pune', 'Mumbai', 'Delhi', 'Bangalore'];
  states    = ['Maharashtra', 'Delhi', 'Karnataka', 'Gujarat'];
  countries = ['India', 'USA', 'UK', 'Canada'];
  categories = ['Management', 'Engineering', 'Arts', 'Science', 'Commerce'];

  availableCourses: AssociateCourse[] = [];
  selectedCourses: AssociateCourse[] = [];
  tempSelectedCourseIds: number[] = [];
  isCourseModalOpen = false;
  isCoursesLoading = false;

  analyticsStats = [
    { label: 'Active Learners',      value: '14.2K',  change: '+12.4%', accent: 'positive' },
    { label: 'Course Completion',    value: '78%',    change: '+5.1%',  accent: 'positive' },
    { label: 'Revenue This Month',   value: '$48.6K', change: '+8.7%',  accent: 'warm'     }
  ];

  enrollmentTrendOptions:      EChartsOption = {};
  categoryPerformanceOptions:  EChartsOption = {};
  engagementSplitOptions:      EChartsOption = {};

  logoPreview: string | null = null;
  logoFile:    File | null   = null;
  defaultLogoPreview         = 'assets/logo_w.png';

  get liveColourCode(): string {
    return this.createForm?.get('colourCode')?.value ?? '#3B82F6';
  }

  isEditMode = false;
  private editingId: number | null = null;
 
  isPasswordModalOpen = false;
  showPassword = false;
  isSaving = false;

  private syncPasswordValidatorsForMode(): void {
    const passwordCtrl = this.createForm?.get('password');
    if (!passwordCtrl) return;

    if (this.isEditMode) {
      passwordCtrl.enable({ emitEvent: false });
      passwordCtrl.clearValidators();
      passwordCtrl.updateValueAndValidity({ emitEvent: false });
    } else {
      passwordCtrl.enable({ emitEvent: false });
      // Use custom validator for exact password rules: 8-20 + upper/lower/digit/special + no spaces
      passwordCtrl.setValidators([Validators.required, passwordValidator]);
      passwordCtrl.updateValueAndValidity({ emitEvent: false });
    }
  }

  private profileId: number | null = null;
  private roleId: number | null = null;

  changePasswordForm!: FormGroup;

  get isEditModePublic(): boolean {
    return this.isEditMode;
  }


  onPasswordFocus(): void {
    if (this.isEditMode) {
      this.openChangePasswordModal();
      this.cdr.detectChanges();
    }
  }


  private openChangePasswordModal(): void {
    this.isPasswordModalOpen = true;


    if (!this.changePasswordForm) {
      this.changePasswordForm = this.fb.group(
        {
          password: ['', [Validators.required, passwordValidator]],
          password_confirmation: ['', [Validators.required, passwordValidator]],
        },
        { validators: this.passwordsMatchValidator },
      );
    } else {
      this.changePasswordForm.reset({ password: '', password_confirmation: '' });
    }
    this.changePasswordForm.markAsPristine();
    this.changePasswordForm.markAsUntouched();
    this.changePasswordForm.updateValueAndValidity({ emitEvent: false });
  }

  private passwordsMatchValidator(group: FormGroup) {
    const p = group.get('password')?.value;
    const pc = group.get('password_confirmation')?.value;
    return p && pc && p === pc ? null : { mismatch: true };
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private courseService: CourseService,
    private toasterService: ToasterService,
    private associateService: AssociateService
  ) {}

  coursesPaginationData: any = null;



  ngOnInit() {

  this.logoPreview = this.defaultLogoPreview;


  // If navigated from Associates -> Analytics, activate Analytics tab (activeTab === 4)
  const tabIndexParam = Number(this.route.snapshot.queryParamMap.get('tabIndex'));
  const tabParam = this.route.snapshot.queryParamMap.get('tab');
  if (tabIndexParam === 4 || tabParam === 'analytics') {
    this.activeTab = 4;
  }



  // Create form FIRST
  this.createForm = this.fb.group({









    client_company_name: ['', [Validators.required, Validators.maxLength(100), nameValidator]],
    aboutCollege: ['', [Validators.required, Validators.maxLength(1000), aboutCollegeValidator]],
    category: ['', [Validators.required]],
    address: ['', [Validators.required, Validators.maxLength(255), addressValidator]],
    city: ['', [Validators.required]],
    state: ['', [Validators.required]],
    country: ['', [Validators.required]],
    pin_code: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],

    contacts: this.fb.array([this.createContact()]),
    emails: this.fb.array([this.createEmail()]),

    adminContacts: this.fb.array([this.createAdminContact()]),
    adminEmails: this.fb.array([this.createAdminEmail()]),

    adminName: ['', [Validators.required, Validators.maxLength(100), nameValidator]],
    designation: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100), designationValidator]],
    username: ['', [Validators.required, Validators.maxLength(30), usernameValidator]],
    password: [{ value: '', disabled: false }, [Validators.required, passwordValidator]],


    whiteLabelled: [0],
    instituteName: ['', [instituteNameValidator]],
    colourCode: ['']
  });

  // THEN check edit mode
  const idParam = this.router.url.includes('/associates/create-associate/')
    ? Number(this.router.url.split('/').pop())
    : NaN;

  if (!Number.isNaN(idParam) && idParam > 0) {
    this.isEditMode = true;
    this.editingId = idParam;
    this.loadClientForEdit(idParam);
  }
  this.syncPasswordValidatorsForMode();

  this.loadCourses();
}

  f(name: string): AbstractControl | null {
    return this.createForm.get(name);
  }
 onSaveChangePassword(): void {
  this.changePasswordForm.markAllAsTouched();

  if (this.changePasswordForm.invalid) {
    console.log('Form Invalid');
    return;
  }

    const userId = this.editingId;
    if (!userId) {
      this.toasterService.setToaster('error', 'Error', 'User id is missing for password change.');
      return;
    }
    const formValue = this.changePasswordForm.value;


const payload = {
  id: userId || 0,
  profile_id: this.roleId || 0,
  role_id: this.roleId || 0,
  password: formValue?.password,
  password_confirmation: formValue?.password_confirmation
};

    this.associateService.changePasswordWithClientDetails(userId || 0, payload).subscribe({
      next: () => {
        this.toasterService.setToaster('success', 'Success', 'Password updated successfully!');
        this.isPasswordModalOpen = false;
        this.changePasswordForm.reset({ password: '', password_confirmation: '' });
        this.changePasswordForm.markAsPristine();
        this.changePasswordForm.markAsUntouched();
      },
      error: (err: any) => {
        this.toasterService.setToaster(
          'error',
          'Error',
          err?.error?.message ?? 'Failed to update password'
        );
      }
    });
  }

  isInvalid(name: string): boolean {
    const ctrl = this.f(name);
    if (!ctrl) return false;
    return ctrl.invalid && (ctrl.touched || ctrl.dirty || this.submitAttempted);
  }

  getArrayCtrl(arrayName: string, index: number, controlName: string): AbstractControl | null {
    return this.createForm.get([arrayName, index, controlName]);
  }

  isArrayInvalid(arrayName: string, index: number, controlName: string): boolean {
    const ctrl = this.getArrayCtrl(arrayName, index, controlName);
    if (!ctrl) return false;
    return ctrl.invalid && (ctrl.touched || ctrl.dirty || this.submitAttempted);
  }

  get contacts(): FormArray {
    return this.createForm.get('contacts') as FormArray;
  }

  createContact(): FormGroup {
    return this.fb.group({
      number: ['', [Validators.required, indianMobileValidator]]
    });
  }

  addContact() { this.contacts.push(this.createContact()); }

  removeContact(index: number) {
    if (this.contacts.length > 1) this.contacts.removeAt(index);
  }
  get emails(): FormArray {
    return this.createForm.get('emails') as FormArray;
  }

  createEmail(): FormGroup {
    return this.fb.group({
      email: ['', [Validators.required, Validators.maxLength(100), emailValidator]]
    });
  }

  addEmail() { this.emails.push(this.createEmail()); }

  removeEmail(index: number) {
    if (this.emails.length > 1) this.emails.removeAt(index);
  }

  onLogoUpload(event: any) {
    const file: File | undefined = event?.target?.files?.[0];
    if (!file) return;

    const allowedMimeTypes = new Set(['image/png', 'image/jpeg', 'image/jpg']);
    if (!allowedMimeTypes.has(file.type)) {
      this.logoFile = null;
      this.logoPreview = this.defaultLogoPreview;
      this.toasterService.setToaster('error', 'Error', 'Only JPG, JPEG, and PNG logos are allowed.');
      return;
    }

    // If you want strict 2MB max as per UI, enforce it here.
    const maxBytes = 2 * 1024 * 1024;
    if (file.size > maxBytes) {
      this.logoFile = null;
      this.logoPreview = this.defaultLogoPreview;
      this.toasterService.setToaster('error', 'Error', 'Logo size must be up to 2MB.');
      return;
    }

    this.logoFile = file;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.logoPreview = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  setTab(tabIndex: number) {
    this.activeTab = tabIndex;
    
    this.submitAttempted = false;
  }

  private applyWhiteLabelledValidation(whiteLabelledValue: any) {
    const isYes = whiteLabelledValue === 1 || whiteLabelledValue === '1' || whiteLabelledValue === true;

    const instituteCtrl = this.f('instituteName');
    const colourCtrl = this.f('colourCode');

    if (!instituteCtrl || !colourCtrl) return;

    if (isYes) {
      instituteCtrl.setValidators([Validators.required, instituteNameValidator]);
      colourCtrl.setValidators([Validators.required]);
    } else {
      instituteCtrl.clearValidators();
      colourCtrl.clearValidators();
      instituteCtrl.setValue(instituteCtrl.value);
      colourCtrl.setValue(colourCtrl.value);
    }

    instituteCtrl.updateValueAndValidity({ emitEvent: false });
    colourCtrl.updateValueAndValidity({ emitEvent: false });
  }

  saveDetailsTab() { 
    this.submitAttempted = true;
    this.createForm.markAllAsTouched();

    const detailFields = ['client_company_name', 'aboutCollege', 'category', 'address', 'city', 'state', 'country', 'pin_code'];
    const detailsValid = detailFields.every(key => this.f(key)?.valid);
    const arraysValid  = this.contacts.valid && this.emails.valid;

    if (!detailsValid || !arraysValid) {
      this.scrollToFirstError();
      return;
    }

    this.activeTab = 1;
    this.submitAttempted = false;
  }

  saveAdminTab() {
    this.submitAttempted = true;
    this.createForm.markAllAsTouched();

    const adminFields  = ['adminName', 'designation', 'username', 'password'];
    const adminValid   = adminFields.every(key => this.f(key)?.valid);
    const arraysValid  = this.adminContacts.valid && this.adminEmails.valid;


    if (!adminValid || !arraysValid) {
      this.scrollToFirstError();
      return;
    }

    this.activeTab = 2;
    this.submitAttempted = false;
  }

  saveCoursesTab() {
    this.submitAttempted = true;

    if (this.selectedCourses.length === 0) return;

    this.activeTab = 3;
    this.submitAttempted = false;
  }

  saveWhiteLabelTab() {
    this.submitAttempted = true;
    this.createForm.markAllAsTouched();

    const whiteLabelValue = this.f('whiteLabelled')?.value;

    if (whiteLabelValue === 1) {
      const wlValid    = this.f('instituteName')?.valid && this.f('colourCode')?.valid;
      const logoValid  = !!this.logoFile || !!this.logoPreview;
      if (!wlValid || !logoValid) {
        this.scrollToFirstError();
        return;
      }
    }

    this.activeTab = 4;
    this.submitAttempted = false;
  }

  onSave() {
    console.log('onSave clicked', {
      invalid: this.createForm?.invalid,
      selectedCourses: this.selectedCourses?.length ?? 0,
      activeTab: this.activeTab
    });
    this.submitAttempted = true;
    this.createForm.markAllAsTouched();

    if (this.createForm.invalid || this.selectedCourses.length === 0) {
      this.scrollToFirstError();
      this.toasterService.setToaster('error', 'Error', 'Please fill all required fields.');
      return;
    }

    const payload   = this.buildCreateClientPayload();
    const formData  = new FormData();

    // Normal fields
formData.append('role_id', String(5));
formData.append('client_company_name', payload.client_company_name);
formData.append('aboutCollege', payload.aboutCollege);
formData.append('category', payload.category);
formData.append('address', payload.address);
formData.append('city', payload.city);
formData.append('state', payload.state);
formData.append('country', payload.country);
formData.append('pin_code', payload.pin_code);
formData.append('poc_name', payload.poc_name);
formData.append('adminName', payload.adminName);
formData.append('designation', payload.designation ?? '');
formData.append('username', payload.username);

if (!this.isEditMode) {
  formData.append('password', payload.password);
}

formData.append('white_labelled', String(payload.white_labelled));
const whiteLabelledValue = payload.white_labelled;
const wlIsEnabled = whiteLabelledValue === 1 || whiteLabelledValue === '1' || whiteLabelledValue === true;
formData.append('institute_details', wlIsEnabled ? payload.institute_details : ("" as any));
formData.append('colour_code', wlIsEnabled ? payload.colour_code : '');
formData.append('is_active', '1');

formData.append('white_labelled', String(payload.white_labelled));




payload.email.forEach((email: string) => {
  formData.append('email[]', email);
});

payload.phone.forEach((phone: string) => {
  formData.append('phone[]', phone);
});

payload.poc_email.forEach((email: string) => {
  formData.append('poc_email[]', email);
});

payload.poc_phone.forEach((phone: string) => {
  formData.append('poc_phone[]', phone);
});

payload.selected_courses.forEach((courseId: number) => {
  formData.append('selected_courses[]', courseId.toString());
});

// Logo
if (this.logoFile) {
  formData.append('logo', this.logoFile, this.logoFile.name);
}

    // update vs create
    const request$ = this.isEditMode && this.editingId
      ? this.associateService.updateClient(this.editingId, formData)
      : this.associateService.createAssociate(formData);

    this.isSaving = true;
    request$.subscribe({
      next: () => {
        this.isSaving = false;
        this.toasterService.setToaster(
          'success',
          'Success',
          this.isEditMode ? 'Associate updated successfully!' : 'Associate created successfully!'
        );
        this.router.navigate(['/associates']);
      },
      error: (err: any) => {
        this.isSaving = false;
        this.toasterService.setToaster(
          'error',
          'Error',
          err?.error?.message ?? (this.isEditMode ? 'Failed to update associate' : 'Failed to create associate')
        );
      }
    });

  }

  onCancel() {
    this.router.navigate(['/associates']);
  }

  onDelete(): void {
    if (!this.isEditMode || !this.editingId) return;

    const ok = window.confirm('Are you sure you want to delete this associate?');
    if (!ok) return;

    this.associateService.deleteClientById(this.editingId).subscribe({
      next: () => {
        this.toasterService.setToaster('success', 'Success', 'Associate deleted successfully!');
        this.router.navigate(['/associates']);
      },
      error: (err: any) => {
        this.toasterService.setToaster(
          'error',
          'Error',
          err?.error?.message ?? 'Failed to delete associate'
        );
      }
    });
  }

  removeCourse(courseId: number) {
    this.selectedCourses = this.selectedCourses.filter(c => c.id !== courseId);
  }

  addCourse() {
    this.tempSelectedCourseIds = this.selectedCourses.map(c => c.id);
    this.isCourseModalOpen = true;
  }

  closeCourseModal() {
    this.isCourseModalOpen = false;
    this.tempSelectedCourseIds = [];
  }

  toggleCourseSelection(courseId: number) {
    this.tempSelectedCourseIds = this.tempSelectedCourseIds.includes(courseId)
      ? this.tempSelectedCourseIds.filter(id => id !== courseId)
      : [...this.tempSelectedCourseIds, courseId];
  }

  saveSelectedCourses() {

    const nextIds = new Set(this.tempSelectedCourseIds);

    this.selectedCourses = this.selectedCourses.filter(c => nextIds.has(c.id));

    const selectedOnPage = this.availableCourses.filter(c => nextIds.has(c.id));

    const map = new Map(this.selectedCourses.map(c => [c.id, c] as const));
    for (const c of selectedOnPage) {
      map.set(c.id, c);
    }
for (const id of nextIds) {
      if (!map.has(id)) {
        map.set(id, { id, name: 'Untitled Course', thumbnail: '' } as AssociateCourse);
      }
    }

    this.selectedCourses = Array.from(map.values());

    this.closeCourseModal();
  }


  isCourseSelected(courseId: number): boolean {
    return this.tempSelectedCourseIds.includes(courseId);
  }

  private scrollToFirstError() {
    setTimeout(() => {
      const el = document.querySelector('.input-error, .select-error, .textarea-error');
      el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 50);
  }

  getCourseThumbnailUrl(thumbnail: string): string {
    const imagePath = String(thumbnail ?? '').trim();
    if (!imagePath) return 'assets/dummy_thumbnail.png';
    if (/^https?:\/\//i.test(imagePath)) return imagePath;
    const apiBase = environment.apiUrl.replace(/api\/v1\/?$/, '');
    const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
    return `${apiBase}${normalizedPath}`;
  }

  private buildCreateClientPayload(): any {
    const detailsEmailArray = (this.createForm.get('emails') as FormArray)?.value ?? [];
    const detailsPhoneArray = (this.createForm.get('contacts') as FormArray)?.value ?? [];
    const detailsEmails     = detailsEmailArray.map((e: any) => e?.email).filter(Boolean);
    const detailsPhones     = detailsPhoneArray.map((p: any) => p?.number).filter(Boolean);

    const adminEmailArray = (this.createForm.get('adminEmails') as FormArray)?.value ?? [];
    const adminPhoneArray = (this.createForm.get('adminContacts') as FormArray)?.value ?? [];
    const adminEmails     = adminEmailArray.map((e: any) => e?.email).filter(Boolean);
    const adminPhones     = adminPhoneArray.map((p: any) => p?.number).filter(Boolean);

    return {
      client_company_name: this.f('client_company_name')?.value,
      aboutCollege:        this.f('aboutCollege')?.value,
      category:            this.f('category')?.value,
      address:             this.f('address')?.value,
      city:                this.f('city')?.value,
      state:               this.f('state')?.value,
      country:             this.f('country')?.value,
      pin_code:             this.f('pin_code')?.value,
      email:               detailsEmails,
      phone:               detailsPhones,
      poc_name:            this.f('adminName')?.value,
      poc_email:           adminEmails,
      poc_phone:           adminPhones,
      adminName:           this.f('adminName')?.value,
      designation:         this.f('designation')?.value,
      username:            this.f('username')?.value,
      
      password:            this.isEditMode ? '' : this.f('password')?.value,
      selected_courses:    this.selectedCourses.map(c => c.id),
      white_labelled:      this.f('whiteLabelled')?.value,
      institute_details:   this.f('instituteName')?.value,
      colour_code:         this.f('colourCode')?.value,
      is_active:           1
    };
  }

  coursesPage = 1;
  coursesLastPage: number | null = null;

  private loadCourses() {
    this.coursesPage = 1;
    this.loadCoursesPage(this.coursesPage);
  }

  private async preloadSelectedCourses(selectedIds: number[]) {
    if (!selectedIds?.length) {
      this.selectedCourses = [];
      return;
    }

    const uniqueIds = Array.from(new Set(selectedIds));

    const fetched: AssociateCourse[] = [];
    for (const id of uniqueIds) {
      try {
        const res: any = await firstValueFrom(this.courseService.getCourseContent(id));
        const body = res?.body ?? res;
        const course = body?.data ?? body;

        fetched.push({
          id: Number(course?.id ?? id),
          name: String(course?.course_name ?? course?.name ?? 'Untitled Course'),
          thumbnail: String(course?.thumbnail ?? '')
        });
      } catch {
      }
    }

    const byId = new Map(fetched.map(c => [c.id, c] as const));
    this.selectedCourses = uniqueIds.map(
      id =>
        byId.get(id) ?? ({ id, name: 'Untitled Course', thumbnail: '' } as AssociateCourse)
    );
  }

  onCoursesPageChange(page: number) {
    this.loadCoursesPage(page);
  }

  private transformPagination(pag: any) {
    if (!pag) return null;
    const pages: number[] = [];
    const last = Number(pag.last_page ?? pag.total_pages ?? 1);
    for (let i = 1; i <= last; i++) pages.push(i);

    const current = Number(pag.current_page ?? pag.current_page_index ?? 1);
    return {
      pages,
      current_page: current,
      prev_page: current > 1 ? current - 1 : null,
      next_page: current < last ? current + 1 : null,
    };
  }

  loadCoursesPage(page: number) {
    this.isCoursesLoading = true;
    const targetPage = Number(page) > 0 ? Number(page) : 1;
    this.coursesPage = targetPage;

    this.courseService.getPublishedCourses(targetPage).subscribe({
      next: (res: any) => {
        const body = res?.body ?? res;
        const apiData = body?.data;
        const courseList = Array.isArray(apiData)
          ? apiData
          : Array.isArray(res?.data)
            ? res.data
            : [];

        const pagination = body?.pagination ?? res?.pagination;
        const lastPage = Number(
          pagination?.last_page ?? pagination?.total_pages ?? 1
        );
        this.coursesLastPage = Number.isFinite(lastPage) && lastPage > 0 ? lastPage : 1;
        this.coursesPaginationData = this.transformPagination(pagination);

        this.availableCourses = courseList.map((c: any) => {
  this.isCoursesLoading = false;

  return this.mapCourse(c);
});
      },

      error: () => {
        this.availableCourses = [];
        this.selectedCourses = [];
        this.toasterService.setToaster('error', 'Error', 'Unable to fetch courses');
      },
      complete: () => {
        this.isCoursesLoading = false;
      }
    });
  }

  private mapCourse(course: any): AssociateCourse {

  const mapped = {
    id: Number(course?.id ?? 0),
    name: String(course?.course_name ?? course?.name ?? 'Untitled Course'),
    thumbnail: String(course?.thumbnail ?? '')
  };


  return mapped;
}

  private parseArrayLike(input: any): string[] {
    if (Array.isArray(input)) return input.map(String);
    if (typeof input === 'string') {
      const trimmed = input.trim();
      if (!trimmed) return [];
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) return parsed.map(String);
      } catch {}

      return trimmed
        .replace(/^\[/, '')
        .replace(/\]$/, '')
        .split(',')
        .map(s => s.trim().replace(/^"|"$/g, ''))
        .filter(Boolean);
    }
    return [];
  }

  private async loadClientForEdit(id: number) {
    try {
      const res: any = await firstValueFrom(this.associateService.getClientById(id));
      const data = res?.data ?? res;
      if (!data) return;

      this.editingId = data.id ?? id;

     
      // Patch basic fields
    this.createForm.patchValue({
        client_company_name: data.client_company_name ?? '',
        aboutCollege: data.about_college ?? data.aboutCollege ?? data.about_college_details ?? '',
        category: data.category ?? '',
        address: data.address ?? '',
        city: data.city ?? '',
        state: data.state ?? '',
        country: data.country ?? '',
        pin_code: data.pin_code ?? data.pin_code ?? '',
        adminName: data.adminName ?? '',
        designation: data.designation ?? '',
        username: data.username ?? '',
        whiteLabelled: Number(data.white_labelled ?? data.whiteLabelled ?? 0),
        instituteName: data.institute_details ?? data.instituteName ?? '',
        colourCode: data.colour_code ?? data.colourCode ?? ''
      });

this.createForm.get('whiteLabelled')?.updateValueAndValidity();
this.createForm.get('instituteName')?.updateValueAndValidity();
this.createForm.get('colourCode')?.updateValueAndValidity();
     
      this.applyWhiteLabelledValidation(this.f('whiteLabelled')?.value);
      const phones = this.parseArrayLike(data.phone);
      const emails = this.parseArrayLike(data.email);
console.log('Phone Raw:', data.phone);
console.log('Email Raw:', data.email);

console.log('Phones Parsed:', phones);
console.log('Emails Parsed:', emails);
      
      const contactsArr = this.contacts;
      while (contactsArr.length) contactsArr.removeAt(0);
      if (phones.length) {
        phones.forEach(p => contactsArr.push(this.fb.group({ number: [p, [Validators.required, Validators.pattern(/^[0-9]{10,15}$/), Validators.maxLength(15)]] })));
      } else {
        contactsArr.push(this.createContact());
      }

     
      const emailsArr = this.emails;
      while (emailsArr.length) emailsArr.removeAt(0);
      if (emails.length) {
        emails.forEach(e => emailsArr.push(this.fb.group({ email: [e, [Validators.required, Validators.maxLength(100), emailValidator]] })));
      } else {
        emailsArr.push(this.createEmail());
      }
      console.log('Contacts FormArray:', this.contacts.getRawValue());
console.log('Emails FormArray:', this.emails.getRawValue());
console.log('Contacts Length:', this.contacts.length);
console.log('Emails Length:', this.emails.length);

    
      const adminPhones = this.parseArrayLike(data.poc_phone ?? data.admin_phone ?? data.adminPhone);
      const adminEmails = this.parseArrayLike(data.poc_email ?? data.admin_email ?? data.adminEmail);

      const adminContactsArr = this.adminContacts;
      while (adminContactsArr.length) adminContactsArr.removeAt(0);
      if (adminPhones.length) {
        adminPhones.forEach(p => adminContactsArr.push(this.fb.group({ number: [p, [Validators.required, Validators.pattern(/^[0-9]{10,15}$/), Validators.maxLength(15)]] })));
      } else {
        adminContactsArr.push(this.createAdminContact());
      }

      const adminEmailsArr = this.adminEmails;
      while (adminEmailsArr.length) adminEmailsArr.removeAt(0);
      if (adminEmails.length) {
        adminEmails.forEach(e => adminEmailsArr.push(this.fb.group({ email: [e, [Validators.required, Validators.maxLength(100), emailValidator]] })));
      } else {
        adminEmailsArr.push(this.createAdminEmail());
      }

      
      this.logoPreview = data.logo ?? data.logo_url ?? data.logoUrl ?? this.logoPreview;

      const selectedIds = Array.isArray(data.selected_courses)
        ? data.selected_courses.map((x: any) => Number(x))
        : [];

      this.tempSelectedCourseIds = selectedIds;

      await this.preloadSelectedCourses(selectedIds);

      this.applyWhiteLabelledValidation(this.f('whiteLabelled')?.value);

    } catch (e) {

      this.toasterService.setToaster('error', 'Error', 'Failed to fetch client details');
    }
  }

 
}